import { routes } from '../constants';

const isUnderRoot = (pathname: string, root: string) =>
	pathname === `/${root}` || pathname.startsWith(`/${root}/`);

// The correction flow sits under /ki-tools in the URL but is its own route tree,
// so it must not pick up the KI Tools page's chat, podcast and dialog behaviour.
export const isAIToolsPagePath = (pathname: string): boolean =>
	isUnderRoot(pathname, routes.aiTools.root) && !isUnderRoot(pathname, routes.corrections.root);
